<template>
  <img
    @click="returnColidee"
    src="~@/assets/img/icons/arrow-left-icon.png"
    class="icon"
    alt="arrow-return-colidee"
  />
</template>

<script>
export default {
  name: 'ButtonReturnColidee',
  props: {
    adminComponent: {
      type: Boolean
    }
  },
  methods: {
    returnColidee () {
      if (this.adminComponent) {
        this.$store.commit('ADMIN_ACTIVE_COMPONENTS', {
          cardList: true,
          parameters: false,
          searchBar: false
        }
        )
      } else {
        this.$router.push({ name: 'Admin' })
      }
    }
  }
}
</script>
<style scoped>
.icon {
  margin-left:10px;
  width: 25px;
  height: 25px;
  cursor: pointer;
}
</style>
